import React from 'react';

export const CreateCities = React.lazy(
  () => import('./CreateCities/CreateCities')
);
export const EditCities = React.lazy(() => import('./EditCities/EditCities'));
